import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    ToasterStoreState,
    ToasterItem,
    AddToasterPayload,
    RemoveToasterPayload,
} from "./types";
import { generateRandomID } from "~/utils/generateRandomID";

// // // //

// Define the initial state of the toaster store
const initialState: ToasterStoreState = {
    toasters: [],
};

// Define the slice for the toaster store, including the initial state and reducer functions
const toasterSlice = createSlice({
    name: "toaster",
    initialState,
    reducers: {
        addToaster: (state, action: PayloadAction<AddToasterPayload>) => {
            state.toasters.push({ ...action.payload, id: generateRandomID() });
        },
        removeToaster: (state, action: PayloadAction<RemoveToasterPayload>) => {
            state.toasters = state.toasters.filter(
                (toaster: ToasterItem) => toaster.id !== action.payload.id,
            );
        },
    },
});

// Export the reducer function and action creators from the slice
export const { addToaster, removeToaster } = toasterSlice.actions;
export const reducer = toasterSlice.reducer;
